/**
 * V番号付きログインIDのバリデーション.
 * ・先頭2桁は大文字小文字混在のアルファベット、残り5桁は数字、＠V番号。V番号は数字9桁
 * ・先頭1桁は大文字小文字混在のアルファベット、残り6桁は数字、＠V番号。V番号は数字9桁
 */
export default {
  validate(value: string | undefined | null): boolean {
    if (!value) return true;
    return (
      !!value.match(/^[A-Z][a-z][0-9]{5}@V[0-9]{9}$/g) ||
      !!value.match(/^[a-z][A-Z][0-9]{5}@V[0-9]{9}$/g) ||
      !!value.match(/^[A-Z][0-9]{6}@V[0-9]{9}$/g) ||
      !!value.match(/^[a-z][0-9]{6}@V[0-9]{9}$/g)
    );
  },
};
